import { lineChartData } from "@components/Dashboard/OperationalDashboard/DemoContent";
import { borderColor, fontSize, fontWeight, lineHeight, margin } from "@mui/system";

export const useStyles = MUITheme => ({
  AppHeader:{
    height: 56,
    padding: '2px 16px !important',
    display: 'flex',
    alignItems:' center',
    justifyContent: 'space-between',
    boxShadow: '0 2px 5px 0 rgba(0,0,0,0.1)',
    background: MUITheme.palette.background.white,
    position:"sticky",
    [MUITheme.breakpoints.down("sm")]: {
      display: "block",
      height: "auto",
    },
    '& .mr-24':{
      marginRight:24
    }
  },
  clinicDropItem:{
    fontSize:13,
    lineHeight:'20px',
    fontWeight:700,
    whiteSpace:'nowrap',
    textOverflow:'ellipsis',
    overflowX:'hidden',
    padding:'6px 16px',
    boxSizing:'border-box',
    '&:hover,&.selected-true':{
      backgroundColor:'rgba(25, 118, 210, 0.12)'
    }
  },
  toolBar:{
    width:"100%",
    justifyContent:"space-between",
    minHeight:"50px",
    paddingLeft:16,
    paddingRight:16,
    [MUITheme.breakpoints.down("sm")]: {
      display: "block",
      height: "auto",
    }
  },
  logoNavContainer:{    
    display: 'flex',
    alignItems: 'center',
    '& h1':{
      width: 280,
      margin: 0,
      lineHeight: 0,
      '& a':{
        display: 'inline-block',
        '& img':{
          maxHeight: 55
        }  
      }      
    },
    [MUITheme.breakpoints.down("sm")]: {
      justifyContent: 'center',
    }
  },
  dropDownUserActionsContainer:{
    display:'flex',
    [MUITheme.breakpoints.down("sm")]: {
      justifyContent: 'space-evenly',
    }
  },
  loggedInActionsContainer:{
    display: 'flex',
    alignItems: 'center'
  },
  clinicSelectorContainer:{
    '& > div':{
      width: 172,
      border: `2px solid ${MUITheme.palette.new.border.ternary}`,
      borderRadius: 6,
      backgroundColor: MUITheme.palette.background.white,
      boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)',
      '&::before':{ display: 'none' },
      '& > div':{ 
        //padding: '8px 19px !important',
        '&:focus':{ backgroundColor: '#fff' }
      },
      '& svg':{  
        //paddingRight: 15,
        color: MUITheme.palette.new.border.ternary
      },
    },
    '& .MuiInputBase-root':{
       fontSize:14,
       padding:8,
       fontFamily:MUITheme.typography.fontFamily.primary,
       paddingRight:'50px !important'
    },
    '& .MuiInputBase-input, button':{
      padding:'0 !important'
    },
    '&:focus':{ outline: 'none'},
    '&.MuiMenu-list':{ padding: 0 },
    '& .MuiOutlinedInput-notchedOutline':{
      border:'none'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline':{
      borderColor:MUITheme.palette.new.header.primaryActive
    }
  },
  menuItemContainer:{ 
    '& li':{
      padding: '10px 15px',
      color: MUITheme.palette.text.primary,
      fontSize: 14,
      fontFamily: MUITheme.typography.fontFamily.secondary,
      '&:hover':{ 
        color: MUITheme.palette.text.blue.secondary,
        backgroundColor: MUITheme.palette.text.white.primary
      }
    }
  },
  disabledMenuItem:{ fontSize: '14px !important'},
  iconsContainer:{
    marginLeft: 16,
    display: 'flex',
    alignItems:' center',
    "& .iconList": {
      paddingLeft: 8,
      display: "flex",
      cursor: "pointer",
      listStyle: "none",
      '& a':{ 
        display: "flex",
        alignItems:'center',
        width: '100%',
        textDecoration: 'none' 
      },
      "& svg": {
        paddingRight: 15,
        color: MUITheme.palette.text.blue.secondary,
        verticalAlign: "middle",
        width:'unset'
      },
      "& span.text": {
        width: '100%',
        color: MUITheme.palette.text.blue.secondary,
        textDecoration: "none",
        fontFamily: MUITheme.typography.fontFamily.primary,
        fontSize: 18,
        lineHeight: '28px'
      },
    }
  },
  NotificationsIcon:{
    marginRight: 23,
    color: MUITheme.palette.text.blue.secondary,
  },
  AccountCircleIcon:{
    borderWidth: 3,
    borderStyle: 'solid',
    borderColor: 'rgb(0 0 0 / 5%)',
    borderRadius: 25,
    boxShadow: '0 0 10px 0 rgba(207,217,223,0.5)',
    fontSize: 37,
    width:24,
    height:24,
    '& svg':{ cursor: 'pointer' },
    '& img':{ cursor: 'pointer' }
  },
  sectionMobile: {
    display: 'flex',
    color: MUITheme.palette.text.primary,
    [MUITheme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  sectionDesktop: {
    display: 'none',
    [MUITheme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },

  dFlex:{
    display: "flex",
    alignItems:'center'
  },
  activeMenu: {
    //background: MUITheme.palette.background.lightBlue,
    color: MUITheme.palette.text.bgBlue,
    fontWeight: 600,
    textDecoration: "none",
    padding:"15px 16px",
    fontSize: 16,
    fontFamily: MUITheme.typography.fontFamily.primary,
    '&.h-menuItem':{
      padding:8
    }
  },
  
  menuItem:{
    textDecoration:'none',
    color: MUITheme.palette.text.primary,
    fontWeight: 600,
    padding:"15px 16px",
    fontSize: 16,
    fontFamily: MUITheme.typography.fontFamily.primary,
    '& hover':{
      color: MUITheme.palette.text.bgBlue,
    },
    '&.h-menuItem':{
      padding:8
    }
  }
});
